import { render } from "./default-layout.vue?vue&type=template&id=41701734&scoped=true"
import script from "./default-layout.vue?vue&type=script&lang=js"
export * from "./default-layout.vue?vue&type=script&lang=js"

import "./default-layout.vue?vue&type=style&index=0&id=41701734&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41701734"]])

export default __exports__